import { IRcaTestResultInsight } from "./IRcaTestResultInsight";

/**
 * The status of a particular result node
 */
export type RcaTestStatus = "Invalid" | "Informational" | "Success" | "SuccessWithWarnings" | "Warning" | "Error" | "FatalError";

/**
 * The display form type used for default render
 */
export const DEFAULT_TEST_RESULT_FORM = "Default";

/**
 * The display form type used for Dane Validation render
 */
export const DANE_VALIDATION_TEST_RESULT_FORM = "DaneValidation";

/**
 * The display form type used for MTA-STS Validation render
 */
export const MTA_STS_VALIDATION_TEST_RESULT_FORM = "MtaStsValidation";

/**
 * The display form type used to select which component to use for render
 */
export type RcaTestResultDisplayFormType =
  | typeof DEFAULT_TEST_RESULT_FORM
  | typeof DANE_VALIDATION_TEST_RESULT_FORM
  | typeof MTA_STS_VALIDATION_TEST_RESULT_FORM;

/**
 * A Remote Connecivity Analyzer test result
 */
export interface IRcaTestResult {
  /**
   * The description of what the test is checking/doing
   */
  TestDescription: string;

  /**
   * A message indicating whether the test was successful or failed.
   */
  ResultDescription: string;

  /**
   * The test status
   */
  Status: RcaTestStatus;

  /**
   * A unique id if this is an error
   */
  ErrorId?: string;

  /**
   * The content URL to learn more about the error if available
   */
  ContentUrl?: string;

  /**
   * The elapsed milliseconds
   */
  ElapsedMilliseconds: number;

  /**
   * The additional details
   */
  AdditionalDetails: string;

  /**
   * The child test result nodes
   */
  Children: IRcaTestResult[];

  /**
   * The set of insights for this result
   */
  Insights: IRcaTestResultInsight[];

  /**
   * The display form type
   */
  DisplayFormType: RcaTestResultDisplayFormType;

  /**
   * Additional result data
   */
  AdditionalResultData: unknown;

  /**
   * A value that uniquely identifies this node
   */
  key?: number | string;

  /**
   * A value indicating whether this result is currently expanded in the view
   */
  expanded?: boolean;
}
